import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "Common/Components/examples/Sidenav";
import theme from "Common/hooks/assets/theme";
import LearnerRoutes from "PlatForms/OrgLMS/Routes/LearnerRoutes/LearnerRoutes";
import { useSoftUIController } from "Common/hooks/context";
import brand from "Common/hooks/assets/images/lmsLogo1.png";
import Login from "Common/Auth/SignIn";
import DashboardLayout from "Common/Components/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "Common/Components/examples/Navbars/DashboardNavbar";
import Trainings from "../Trainings/Trainings";
import GroupDetail from "../TrainingGroup/GroupDetail";
import TrainingOverView from "../TrainingGroup/TrainingOverview/TrainingOverview";
import ViewHistory from "../TrainingGroup/TrainingOverview/viewReportIssueHistory";
import { showSidebar } from "Common/Client/routeUtils";
import { getRoutes } from "Common/Client/routeUtils";
import AllDeadlines from "../LandingPage/AllDeadlines";
import AllCourses from "../LandingPage/AllCourses";
import Register from "Common/Auth/SignUp";
import LearnerProfile from "../LearnerProfile/learnerProfile";
import CourseItems from "../../Admin/TrainingLibrary/Courseitem";
import CompletedTraining from "../Trainings/CompletedTrainings";
import PersonalityAssessmentForm from "../PesonalityAssessment/PersonalityAssessmentForm";
import PersonalityAssessmentReport from "../PesonalityAssessment/PersonalityAssesssmentReport";

function LearnerContent() {
  const [controller] = useSoftUIController();
  const { layout, sidenavColor } = controller;
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);

  return (
    <>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {layout === "dashboard" && showSidebar && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Learner"
              routes={LearnerRoutes}
            />
          </>
        )}
        <DashboardLayout>
          <DashboardNavbar />
          <Routes>
            {getRoutes(LearnerRoutes)}
            <Route path="*" element={<Navigate to="/learner-dashboard" />} />
            <Route path="/login" name="Login" element={<Login />} />
            <Route path="/register" name="Register" element={<Register />} />
            <Route path="/training-inflight" name="training-inflight" element={<Trainings />} />
            <Route path="/training-list" name="training-list" element={<CompletedTraining />} />
             <Route path="/group-detail/:id" name="group-detail" element={<GroupDetail />} />
            <Route
              path="/view-training-detail"
              name="view-training-detail"
              element={<TrainingOverView />}
            />
            <Route
            path="/personality-assessment"
            name="Personality Assessment Form"
            element={<PersonalityAssessmentForm/>}
            />
            <Route
            path="/personality-assessment-report"
            name="Personality Assessment Report"
            element= {<PersonalityAssessmentReport />}
            />

            

            <Route path="/view-history" name="View History" element={<ViewHistory />} />
            <Route path="/all-deadlines" name="All Deadlines" element={<AllDeadlines />} />
            <Route path="/all-courses" name="All Courses" element={<AllCourses />} />
            <Route path="/learner-profile" name="Learner Profile" element={<LearnerProfile />} />
            <Route path="/course-items" element={<CourseItems />} />
          </Routes>
        </DashboardLayout>
      </ThemeProvider>
    </>
  );
}
export default LearnerContent;
